import ApiService from "@/common/api.service"
import { NotificationService } from "@/common/api.service"

import { FETCH_NAVIGATION_BAR_STATUS, CONTACT_QUERY, FETCH_INBOX_MESSAGES, FETCH_SENT_MESSAGES, FETCH_INDIVIDUAL_NOTIFICATION,MARK_NOTIFICATION_AS_READ, GLOBALS_RESET_STATE } from "./actions.type"
import { SET_NAVIGATION_BAR_STATUS, SET_NAVBAR_WIDTH, SET_INBOX_MESSAGES, SET_SENT_MESSAGES, SET_INBOX_COUNTER, SET_INDIVIDUAL_NOTIFICATION, SET_ROUTER_ENTER, RESET_GLOBAL_STATE ,SET_LOADING, SET_LOGGED_IN,SET_SNACKBAR, SET_ERROR_CONTACT } from "./mutations.type"

const initialState = () => {
    return {
        mini: false,
        loadingdata: false,
        snackbarStatus: false,
        snackbarMessage: '',    
        errorscontact: null,
        routerenter: false,
        loggedin: false,
        widthValue: 80,
        inboxMessages:null,
        sentMessages:null,
        individualnotification:null,
        openMessageCount:0,
    }
}

let state = initialState()

const getters = {
    mini(state) {
        return state.mini
    },    
    loadingdata(state) {
        return state.loadingdata
    },    
    widthValue(state) {
        return state.widthValue
    }, 
    routerenter(state)  {
       return state.routerenter
    },
    loggedin(state) {
        return state.loggedin
    },  
    inboxMessages(state) {
        return state.inboxMessages
    }, 
    sentMessages(state) {
        return state.sentMessages
    },   
    individualnotification(state) {
        return state.individualnotification
    },
    openMessageCount(state) {
        return state.openMessageCount
    }        
};

const actions = {
    [FETCH_NAVIGATION_BAR_STATUS](context) {
        context.commit(SET_NAVIGATION_BAR_STATUS)
    },
    async [FETCH_INBOX_MESSAGES](context, slug) {
        const { data } = await NotificationService.get(slug)
        if(slug.includes("is_read")){
            context.commit(SET_INBOX_COUNTER, data.data)
        }
        context.commit(SET_INBOX_MESSAGES, data.data)
        return data;
    },
    async [FETCH_SENT_MESSAGES](context, slug) {
        const { data } = await NotificationService.get(slug)
        context.commit(SET_SENT_MESSAGES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_NOTIFICATION](context, slug) {
        const { data } = await NotificationService.get(slug)
        context.commit(SET_INDIVIDUAL_NOTIFICATION, data.data)
        return data;
    },
    [MARK_NOTIFICATION_AS_READ](context, payload) {
        return NotificationService.markasread(payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_CONTACT, error.response.data.errors)
        });
    }, 
    [CONTACT_QUERY](context, payload) {
        return ApiService.post("contact-us", payload)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_CONTACT, error.response.data.errors)
        });
    }, 
    [GLOBALS_RESET_STATE]({ commit }) {
        commit(RESET_GLOBAL_STATE)
    }


};

const mutations = {
    [SET_NAVIGATION_BAR_STATUS](state) {
        state.mini = (state.mini ? false : true)
    },
    [SET_INBOX_MESSAGES](state, messages) {
        state.inboxMessages = messages
    }, 
    [SET_SENT_MESSAGES](state, messages) {
        state.sentMessages = messages
    }, 
    [SET_INBOX_COUNTER](state, messages) {
        state.openMessageCount = messages.length
    },  
    [SET_INDIVIDUAL_NOTIFICATION](state, notification) {
        state.individualnotification = notification
    },  
    [SET_LOGGED_IN](state, status) {
        state.loggedin = status
    },    
    [SET_SNACKBAR](state, payload) {
        state.snackbarStatus = payload.status 
        state.snackbarMessage = payload.message
    }, 
    [SET_ROUTER_ENTER](state, status) {
        state.routerenter = status
    },   
    [SET_LOADING](state, payload) {
        state.loadingdata = payload 
    },
    [SET_NAVBAR_WIDTH](state, width) {
        state.widthValue = width
    },
    [SET_ERROR_CONTACT](state, errors) {
        state.errorscontact = errors
    },
    [RESET_GLOBAL_STATE](state) {
        Object.assign(state, initialState())
    }    
};

export default {
    state,
    getters,
    actions,
    mutations
};